import { render, staticRenderFns } from "./MultiselectInput.vue?vue&type=template&id=cfb63eb4&"
import script from "./MultiselectInput.vue?vue&type=script&lang=ts&"
export * from "./MultiselectInput.vue?vue&type=script&lang=ts&"
import style0 from "./MultiselectInput.vue?vue&type=style&index=0&id=cfb63eb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports